import { getStoreOptions } from '@gozoki/api'
import { workShiftClockActionEnum } from '@gozoki/api-types'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { WorkShiftClockHeader } from '~/components/routes/workshift-attendance/workshift-attendance-header'
import { WorkShiftAttendanceLog } from '~/components/routes/workshift-attendance/workshift-attendance-log'

export const Route = createFileRoute('/_nosidebar/workshift-attendance/$storeId')({
  component: RouteComponent,
  validateSearch: z.object({
    collaboratorId: z.number().optional(),
    action: z.enum(workShiftClockActionEnum).optional(),
  }),
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
})

function RouteComponent() {
  const { storeId } = Route.useParams()

  const { data: store, isLoading: isLoadingStore } = useQuery(getStoreOptions(storeId))

  if (isLoadingStore && !store) {
    return <div>Chargement...</div>
  }

  if (!store) {
    return <div>Boutique non trouvée</div>
  }

  return (
    <div className="flex flex-col gap-4 p-2 bg-sidebar h-dvh">
      <WorkShiftClockHeader storeName={store.label} />
      <WorkShiftAttendanceLog storeName={store.label} storeId={storeId} />
    </div>
  )
}
